import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './NavEtica.css'
import brasao from '../../assets/crefito.png'

const Membro = (props) => {
    const [mensagem, setMensagem] = useState({numeroMensagens: 0}) 

    useEffect(() => {
        const id = localStorage.idE
        const url = `/api/mensagem/getMsgNumberEtica/${id}`
        axios(url)
            .then(res => {
                setMensagem(res.data)
            })
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    function logout() {
        localStorage.clear()

        window.location = "/etica"
    }

    if (window.matchMedia("(min-width:600px)").matches) {
        return (
            <div className="nav">
                <a href="/etica"><img src={brasao} alt="Brasil" className='brasaoNav' /></a>
                <div className="dropdown">
                    <span className='drop dropPed'>Processo Ético<i className="bi bi-caret-down-fill iconeDown"></i></span>
                    <div className="caixa1">
                        <div className="caixao">
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-file-earmark-plus"></i><a href="/etica/novoPed">Adicionar PED</a></span>
                            </div>
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-search"></i><a href="/etica/buscaPed">Pesquisar PED</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dropdown">
                    <a className='drop dropDPed' a href="/etica/dash">Data Analysis</a>
                </div>
                <div className="dropdown">
                    <span className='drop dropSMembro'>Suporte<i className="bi bi-caret-down-fill iconeDown"></i></span>
                    <div className="caixaSMembro">
                        <div className="caixao">
                            {renderSuporte()}
                        </div>
                    </div>
                </div>
                <div className="dropdown">
                    <span className='drop dropMPed'>Mensagens<i className="bi bi-caret-down-fill iconeDown"></i></span>
                    <div className="caixaMPed">
                        <div className="caixao">
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-envelope-exclamation"></i>
                                    <a href="/etica/minhasMensagens">Minhas Mensagens</a>
                                    <span className="spanMensagensEtica">{mensagem.numeroMensagens}</span>
                                </span>
                            </div>
                            <div className='mt-2'>
                                <span><i className="iNav bi bi-envelope"></i><a href="/etica/enviarMensagem">Enviar Mensagem</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dropdown">
                    <a href="/etica/senha" className='drop dropSPed'>Senha</a>
                </div>
                <a onClick={e => logout()}>
                    <span className='drop drop7'><i className="bi bi-box-arrow-in-right"></i>Sair</span>
                </a>
            </div>
        )
    } else {
        return (
            <div className="nav">
                <div className="dropdown">
                    <span className='menuPosition'><i className="bi bi-menu-up iMenu"></i></span>
                    <div className="caixaMobile">
                        <div className="caixaoMobile">
                            <div>
                                <div className="dropMobile">
                                    <span>Processo Ético<i className="bi bi-caret-down-fill iconeDown"></i></span>
                                    <div className="dropExtend">
                                        <div className='mt-3'>
                                            <span><i className="bi bi-file-earmark-plus"></i><a href="/etica/novoPed">Adicionar PED</a></span>
                                        </div>
                                        <div className='mt-3'>
                                            <span><i className="bi bi-search"></i><a href="/etica/buscaPed">Pesquisar PED</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <a href="/#" className="linkMobile">Data Analysis</a>
                            </div>
                            <div className='mt-3'>
                                <div className="dropMobile">
                                    <span>Suporte<i className="bi bi-caret-down-fill iconeDown"></i></span>
                                    <div className="dropExtend">
                                        {renderSuporte()}
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <div className="dropMobile">
                                    <span>Mensagens<i className="bi bi-caret-down-fill iconeDown"></i></span>
                                    <div className="dropExtend">
                                        <div className='mt-3'>
                                            <span><i className="bi bi-envelope-exclamation"></i>
                                                <a href="/etica/minhasMensagens">Minhas Mensagens</a>
                                                <span className="spanMensagensEtica">{mensagem.numeroMensagens}</span>
                                            </span>
                                        </div>
                                        <div className='mt-3'>
                                            <span><i className="bi bi bi-envelope"></i><a href="/etica/enviarMensagem">Enviar Mensagem</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <a href="/etica/senha" className="linkMobile">Senha</a>
                            </div>
                        </div>
                    </div>
                </div>
                <a href="/etica" className='brasaoHorizontal'>
                    <div className="brasaoVertical">
                        <img src={brasao} alt="Brasil" className='brasaoNav' />
                    </div>
                </a>
                <div className="sairMobile">
                    <a onClick={e => logout()}>
                        <span><i className="bi bi-box-arrow-in-right"></i> Sair</span>
                    </a>
                </div>
            </div>
        )
    }

    function renderSuporte() {
        if (localStorage.tipoE == "interno") {
            return (
                <div className='mt-2'>
                    <span><i className="iNav bi bi-envelope"></i><a href="/suporteInterno">Chamados</a></span>
                </div>
            )
        } else {
            return (
                <React.Fragment>
                    <div className='mt-2'>
                        <span><i className="iNav bi bi-envelope-plus"></i><a href="/etica/novoChamado">Novo Chamado</a></span>
                    </div>
                    <div className='mt-2'>
                        <span><i className="iNav bi bi-envelope"></i><a href="/etica/meusChamados">Meus Chamados</a></span>
                    </div>
                </React.Fragment>
            )
        }
    }
}
export default Membro